import { adminGet } from "../../http";
import { SettingConfigData } from "../../../types/Setting/SettingConfigData";

export const searchLibraryVideo = async (
  query: string,
  config: SettingConfigData | null
): Promise<{
  id: string;
  serviceId: string;
  serviceName: string;
  thumbnail_url: string;
}[]> => {
  return adminGet(
    "announcements/video_library",
    { query: query },
    { requireUser: true, config }
  );
};
